import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-avt-dialog-delete',
  templateUrl: './avt-dialog-delete.component.html',
  styleUrls: ['./avt-dialog-delete.component.scss'],
})
export class AvtDialogDeleteComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AvtDialogDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public router: Router
  ) {
    this.route = this.router.url;
  }
  message: string = 'Voulez-vous supprimer cet élément ?';
  btnOk = { class: 'colorRed', icon: 'delete', text: 'Supprimer' };
  btnAnnuler = { class: 'colorRed', icon: 'close', text: 'Annuler' };
  btnDeactivate = {
    class: 'colorRed',
    icon: 'close',
    text: 'Désactiver Tarif',
  };
  route: any;
  ngOnInit() {
    if (this.data != undefined) {
      if (this.data.message != undefined) {
        this.message = this.data.message;
      }
      if (this.data.btnOk != undefined) {
        this.btnOk = this.data.btnOk;
      }
      if (this.data.btnAnnuler != undefined) {
        this.btnAnnuler = this.data.btnAnnuler;
      }
      if (this.data.btnDeactivate != undefined) {
        this.btnDeactivate = this.data.btnDeactivate;
      }
    }

    console.log(this.route);
  }
  close(action) {
    this.dialogRef.close(action);
  }
  logResult(anything: any) {
    console.log(anything);
  }
}
